export const ADD_GPAGroup = 'ADD_GPAGroup';
export const DELETE_GPAGroup = 'DELETE_GPAGroup';